import { css } from '@spectrum-web-components/base';
const styles = css`
    :host{display:inline-flex}:host(:not([selected])){display:none}
`;
export default styles;